module.exports = __webpack_public_path__ + "img/F40EUR.71570498.png";